import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { RequestService } from 'src/app/services/request.service';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { Subject } from 'rxjs';
import Product from '../../../model/product/product';
import BrowserHelper from '../../../helpers/browser-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import PMSColor from 'src/app/model/company/pmscolor';
import DateHelper from 'src/app/helpers/date-helper';
import * as moment from 'moment-timezone';
import { BaseProject } from '../../../model/project/base-project';
import { StringHelper } from 'src/app/helpers/string-helper';
import { QuotationSitevisitPendingComponent } from '../../../modals/quotation-sitevisit-pending/quotation-sitevisit-pending.component';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Pickup } from '../../../model/project/pickup';
import { SubProject } from '../../../model/project/sub-project';
import Employee from 'src/app/model/product/employee';
import UserHelper from 'src/app/helpers/user-helper';
import { User } from 'src/app/model/user';
import Company from 'src/app/model/company/company';
import ProjectContact from 'src/app/model/company/projectContact';
import { BoardPartAddedEvent } from 'src/app/events/board-part-added';
import { StandardStickerPartAddedEvent } from 'src/app/events/standard-sticker-part-added';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ContactPickerEvent } from 'src/app/shared/contact-picker/contact-picker-event';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { EditProjectHelper } from './edit-project-helper';
import { SnackService } from 'src/app/services/snack.service';
import Asset from 'src/app/model/asset';
import { NotificationMailComponent } from 'src/app/modals/notification-mail/notification-mail.component';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'edit-project',
  templateUrl: './edit-project.component.html',
  styleUrls: ['./edit-project.component.scss'],
})
export class EditProjectComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  isCollapsedCompany: boolean;
  isCollapsedProject: boolean;
  isCollapsedPlacement: boolean;
  isCollapsedAdjustment: boolean;
  isCollapsedSoldRented: boolean;
  isCollapsedRepo: boolean;
  isCollapsedOverview: boolean;
  isCollapsedBilling: boolean;
  isHiddenProject: boolean;
  isHiddenPlacement: boolean;
  isHiddenAdjustment: boolean;
  isHiddenSoldRented: boolean;
  isHiddenOverview: boolean;
  isHiddenBilling: boolean;
  init = false;
  showAddProduct = true;
  @Input()
  project = new Project();
  @Input()
  model = new BaseProject();
  @Input()
  productAdded: Subject<Product>;
  @Input()
  boardPartAdded: Subject<BoardPartAddedEvent>;
  @Input()
  standardStickerPartAdded: Subject<StandardStickerPartAddedEvent>;
  @Input()
  standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Input()
  projectContactIdAssigned: Subject<ProjectContact[]>;
  @Output()
  public save = new EventEmitter();

  @Output()
  public immediateSave = new EventEmitter();

  private involvedCompanies: Company[];
  involvedCompanyNames: string;

  pmsColorAdded: Subject<PMSColor> = new Subject<PMSColor>();
  private invoiceSent: Subject<any> = new Subject<any>();
  safari: boolean;
  private dialogModalRef: MatDialogRef<QuotationSitevisitPendingComponent>;

  firstDesigner: Employee;
  placers: Employee[] = [];
  invoiceSentDateString: string = '';

  generatingPlacementSticker = false;

  constructor(
    private requestService: RequestService,
    private employeeChoicesService: EmployeeChoicesService,
    private snackService: SnackService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private dialog: MatDialog
  ) {
    super();
    this.isHiddenBilling = true;
    this.isHiddenPlacement = true;
    this.isHiddenAdjustment = true;
    this.isHiddenSoldRented = true;
    this.isHiddenProject = true;
    this.isHiddenOverview = true;
    this.expandCompany(false);
  }

  ngOnInit() {
    this.calculateInvolvedCompanies();
    if (this.project.id == null) {
      this.showAddProduct = false;
      this.project.products = [];
    }
    this.safari = BrowserHelper.isSafari();
    if (this.model.id) {
      this.initSubProject();
      this.isCollapsedCompany = true;
      this.isCollapsedOverview = false;
      this.isHiddenProject = false;
      this.isHiddenPlacement = false;
      this.isHiddenOverview = false;
      this.isHiddenAdjustment = false;
      this.isHiddenSoldRented = false;
      this.isHiddenBilling = false;
    } else {
      this.model.withPlacement = true;
    }
    this.employeeChoicesService.updateEmployeeChoices();
    this.initializeDisplayVariables();
    this.initializeDisplaySubscriptions();
    this.init = true;
  }

  initSubProject(): void {
    if (this.model.pickup == null) {
      this.model.pickup = new Pickup();
    }
    if (
      this.project.projectContacts != null &&
      this.project.projectContacts.length > 0
    ) {
      EditProjectHelper.setPlacementInvoices(
        this.model,
        this.project,
        this.projectDisplayObservableService
      );
    }
    this.init = true;
  }

  initializeDisplayVariables() {
    if (CollectionHelper.isPopulated(this.project.products)) {
      this.calculateFirstDesigner();
      this.calculatePlacers();
    }
    if (CollectionHelper.isPopulated(this.model.projectInvoices)) {
      this.calculateInvoiceSentDateString();
    }
  }

  initializeDisplaySubscriptions() {
    this.addSubscription(
      this.projectDisplayObservableService.getDesignerPickedSubscribable(),
      () => {
        this.calculateFirstDesigner();
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getPlacersChangedSubscribable(),
      () => {
        this.calculatePlacers();
      }
    );
    this.addSubscription(this.invoiceSent, () => {
      this.calculateInvoiceSentDateString();
    });
  }

  private calculateFirstDesigner() {
    for (const product of this.project.products) {
      if (product.designer != null) {
        this.firstDesigner = product.designer;
        break;
      }
    }
  }

  private calculatePlacers() {
    if (this.project.products == null || this.project.products.length === 0) {
      this.placers = [];
    }
    let idToPlacer = new Map<number, Employee>();
    for (let product of this.project.products) {
      if (
        product.productPlacement == null ||
        product.productPlacement.placers == null ||
        product.productPlacement.placers.length === 0
      ) {
        continue;
      }
      for (let placer of product.productPlacement.placers) {
        idToPlacer.set(placer.id, placer);
      }
    }
    if (idToPlacer.size === 0) {
      this.placers = [];
    }
    this.placers = Array.from(idToPlacer.values());
  }

  private calculateInvoiceSentDateString() {
    if (
      this.model.projectInvoices == null ||
      this.model.projectInvoices.length === 0
    ) {
      this.invoiceSentDateString = '';
    }
    let toPrintDate = null;
    for (let projectInvoice of this.model.projectInvoices) {
      if (
        projectInvoice.type === 'PlacementInvoice' &&
        projectInvoice.sentDate != null
      ) {
        toPrintDate = DateHelper.max(toPrintDate, projectInvoice.sentDate);
      }
    }
    if (toPrintDate == null) {
      this.invoiceSentDateString = null;
      return;
    }
    this.invoiceSentDateString =
      ' - factuur verstuurd (' +
      moment.tz(toPrintDate, 'Europe/Brussels').format('DD/MM/YYYY') +
      ')';
  }

  nextPart() {
    this.isHiddenProject = false;
    this.saveSubProject();
    this.expandProject(false);
  }

  saveContacts(event: ContactPickerEvent) {
    EditProjectHelper.handleSaveContacts(
      event,
      this.project,
      this.model,
      this.projectDisplayObservableService
    );
    this.isHiddenProject = false;
    this.init = true;
    if (this.project.products == null) {
      this.project.products = [new Product()];
    }
    if (this.project.products.length === 0) {
      this.project.products.push(new Product());
    }
    this.calculateInvolvedCompanies();
    this.projectDisplayObservableService
      .getProjectContactsChangedSubscribable()
      .next();
    this.saveSubProject();
  }

  projectsSet(event) {
    this.isHiddenPlacement = false;
    this.expandPlacement(false);
    window.scrollTo(0, 0);
  }

  addProduct() {
    this.showAddProduct = false;
    let prod = new Product();
    //prod.type = 'WindowSticker';
    this.project.products.push(prod);
  }

  productTypeWasSelected() {
    this.projectDisplayObservableService
      .getProductExecutedSubscribable()
      .next();
    this.showAddProduct = true;
  }

  placementsSet(event) {
    this.model.status = 'Nieuw';
    this.saveSubProjectImmediate();
    this.isHiddenAdjustment = false;
    this.expandOverview(false);
    window.scrollTo(0, 0);
  }

  collapseAllSections() {
    this.isCollapsedCompany = true;
    this.isCollapsedProject = true;
    this.isCollapsedAdjustment = true;
    this.isCollapsedSoldRented = true;
    this.isCollapsedRepo = true;
    this.isCollapsedPlacement = true;
    this.isCollapsedOverview = true;
    this.isCollapsedBilling = true;
  }

  openActions() {
    const setSubProjectSubject = new Subject<SubProject>();
    const setProjectSubject = new Subject<Project>();
    this.addSubscription(
      setSubProjectSubject,
      (subProject: SubProject) => (this.model = subProject)
    );
    this.addSubscription(setProjectSubject, (project: Project) => {
      if (
        CollectionHelper.isPopulated(this.project.products) &&
        CollectionHelper.isPopulated(project.products)
      ) {
        this.project.products.forEach((p, i) => {
          p.designSentToCustomer = project.products[i].designSentToCustomer;
          p.customerApproves = project.products[i].customerApproves;
          p.designFinished = project.products[i].designFinished;
        });
      }
    });
    let config = {
      project: this.project,
      subProject: this.model,
      loadProject: true,
      setSubProjectSubject: setSubProjectSubject,
      setProjectSubject: setProjectSubject,
    };
    this.dialogModalRef = this.dialog.open(QuotationSitevisitPendingComponent, {
      data: config,
    });
    this.addSubscription(
      this.dialogModalRef.afterClosed(),
      (project: Project) => {
        if (project) {
          this.model = project.subProjects.find(
            (subProject) => subProject.id === this.model.id
          );
          if (
            CollectionHelper.isPopulated(this.project.products) &&
            CollectionHelper.isPopulated(project.products)
          ) {
            this.project.products.forEach((p, i) => {
              p.designSentToCustomer = project.products[i].designSentToCustomer;
              p.customerApproves = project.products[i].customerApproves;
              p.designFinished = project.products[i].designFinished;
            });
          }
          this.saveSubProject();
        }
        setSubProjectSubject.complete();
        setProjectSubject.complete();
      }
    );
  }

  openNotificationMailModal() {
    const config = {
      userOptions: ProjectHelper.getInvolvedSubprojectUsers(
        this.model,
        this.project
      ).filter((u) => u.email != null && u.email.toString() !== ''),
      project: this.project,
      subProjectId: this.model.id,
      showQuotationAddress: false,
      selectAll: false,
      performSend: true,
    };
    this.dialog.open(NotificationMailComponent, { data: config });
  }

  expandCompany(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedCompany = value;
  }

  expandProject(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedProject = value;
  }

  expandPlacement(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedPlacement = value;
  }

  expandOverview(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedOverview = value;
  }

  expandAdjustment(value: boolean) {
    this.collapseAllSections();
    this.isCollapsedAdjustment = value;
  }

  scrollTo(element: HTMLElement) {
    // if we want the very top of the section to be visible, we need to account for that extra
    //60 is the height of the top bar
    window.scrollTo(0, element.offsetTop - 60);
  }

  setWithPlacement(value: boolean) {
    this.model.withPlacement = value;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.saveSubProject();
  }

  setPickupInfo(value) {
    this.model.pickup.extraInfoPickup = value;
    this.saveSubProject();
  }

  setPickupReady(value) {
    this.model.pickup.ready = value;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.saveSubProject();
  }

  getAllProductsExecuted(): boolean {
    for (let product of this.project.products) {
      if (product.productPlacement != null) {
        if (!product.productPlacement.executionComplete) {
          return false;
        }
      } else if (product.productPlacement == null && this.model.withPlacement) {
        return false;
      }
    }
    return true;
  }

  // addAdjustment() {
  //   if (this.model.adjustments == null) {
  //     this.model.adjustments = [];
  //   }
  //   this.model.adjustments.push(new Adjustment());
  //   this.saveProject();
  // }

  getMostRecentPlacementDate(project: Project) {
    let toReturn = ProjectHelper.getMostRecentPlacementDate(project);
    return toReturn == null ? '' : ' (' + toReturn.format('DD/MM/YYYY') + ')';
  }

  removeObsoleteProductPhoneNumbers() {
    if (this.project.projectContacts != null && this.project.products != null) {
      let projectContactIds = this.project.projectContacts
        .map((pc) => pc.id)
        .filter((id) => id != null);
      this.project.products.forEach((p) => {
        if (p.productPhoneNumbers != null) {
          for (let i = p.productPhoneNumbers.length - 1; i >= 0; i--) {
            let productPhoneNumber = p.productPhoneNumbers[i];
            if (
              productPhoneNumber.projectContact != null &&
              !projectContactIds.includes(productPhoneNumber.projectContact.id)
            ) {
              p.productPhoneNumbers.splice(i, 1);
            }
          }
        }
      });
    }
  }

  calculateInvolvedCompanies() {
    this.involvedCompanies = ProjectHelper.getInvolvedCompanies(this.project);
    this.involvedCompanyNames = CollectionHelper.isPopulated(
      this.involvedCompanies
    )
      ? StringHelper.join(
          this.involvedCompanies.map((c) => c.regularName),
          ', '
        )
      : '';
  }

  getCompanyNames() {
    if (this.involvedCompanies == null) {
      return '';
    }
    return StringHelper.join(
      this.involvedCompanies.map((c) => c.regularName),
      ', '
    );
  }

  saveSubProject() {
    this.save.emit(this.model);
  }

  saveSubProjectImmediate() {
    this.immediateSave.emit(this.model);
  }

  atLeastOneProductPlacer() {
    return (
      this.model.withPlacement &&
      this.project.products != null &&
      this.project.products.some(
        (p) =>
          p.productPlacement != null &&
          p.productPlacement.placers != null &&
          p.productPlacement.placers.length > 0
      )
    );
  }

  getLetters(employee: Employee) {
    return UserHelper.getLettres(employee.user);
  }

  getName(employee: Employee) {
    return UserHelper.getName(employee.user);
  }

  getUserLetters(user: User) {
    return UserHelper.getLettres(user);
  }

  getUserName(user: User) {
    return UserHelper.getName(user);
  }

  generatePlacementSticker() {
    this.generatingPlacementSticker = true;
    this.addSubscription(
      this.requestService.post(
        {},
        'subprojects/generatePlacementSticker/' + this.model.id
      ),
      (res) => {
        if (res.success === false) {
          this.snackService.showError(res.message);
        } else {
          GeneralHelper.downloadAsset(<Asset>res);
        }
        this.generatingPlacementSticker = false;
      },
      (err) => {
        this.snackService.showError(err);
        this.generatingPlacementSticker = false;
      }
    );
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
